import _mountRoot from 'rlink-router/actions/_mountRoot.jsx';
import returnTo from 'rlink-router/actions/returnTo';
import _initRouteDefinitions from 'rlink-router/actions/_initRouteDefinitions';
import _initBuildContextConstants from 'rlink-router/actions/_initBuildContextConstants';

export default function initApp (buildContext, mountRootId) {
  return async (dispatch, getState, {navigationEngine}) => {
    await Promise.all([
      dispatch(_initBuildContextConstants({
        defaultLocale: buildContext.defaultLocale,
        defaultRegion: buildContext.defaultRegion,
        useLongCaches: buildContext.useLongCaches,
        useLiveSafetyFeatures: buildContext.useLiveSafetyFeatures,
        contentRoot: buildContext.contentRoot,
      })),
      dispatch(_initRouteDefinitions(buildContext)),
    ]);
    await navigationEngine.onReturnToState(
      (state, direction) => {
        return dispatch(returnTo(buildContext, state, direction));
      } );
    await dispatch(_mountRoot(buildContext, mountRootId));
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/initApp.js